var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36909",
    "data-name": "Group 36909",
    transform: "translate(-1142 -370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_0be1d8aa3b29fc0d0c5ae69296a7f21f",
    "data-name": "0be1d8aa3b29fc0d0c5ae69296a7f21f",
    d: "M10.659,4.11H15.1A.555.555,0,1,0,15.1,3h-4.44a.555.555,0,1,0,0,1.11Zm8.872,5.231,1.509-1.509a.555.555,0,0,0-.785-.785L18.747,8.557a8.843,8.843,0,0,0-11.735,0L5.5,7.047a.555.555,0,0,0-.785.785L6.227,9.341a8.879,8.879,0,1,0,13.3,0ZM12.879,22.978A7.768,7.768,0,0,1,7.371,9.731c.006-.005.013-.007.019-.012S7.4,9.706,7.4,9.7a7.76,7.76,0,0,1,10.964.013l.009.009a7.765,7.765,0,0,1-5.5,13.255Zm.555-9.332V11.324a.555.555,0,0,0-1.11,0v2.322a1.665,1.665,0,1,0,1.11,0Z",
    transform: "translate(1141.121 368.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1168",
    "data-name": "Rectangle 1168",
    width: 24,
    height: 24,
    transform: "translate(1142 370)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.85503e083364827505b387121e7109b3.svg";
export { ForwardRef as ReactComponent };